module.exports = __webpack_public_path__ + "img/jisusaiche_bg.f503314c.png";